import { IFilterElement } from "@saleor/components/Filter";
import { maybe } from "@saleor/misc";
import moment from "moment";

import {
  createFilterTabUtils,
  createFilterUtils,
  getGteLteVariables,
  getMinMaxQueryParam
} from "../../../../utils/filters";
import {
  CustomerActivityFilterKeys,
  CustomerActivityListFilterOpts
} from "../../components/CustomerActivityListPage/filters";
import {
  CustomerActivityListUrlFilters,
  CustomerActivityListUrlFiltersEnum,
  CustomerActivityUrlQueryParams
} from "../../urls";

export const CUSTOMER_REPORTS_FILTERS_KEY = "CustomerInfoFilters";

export function getFilterOpts(
  params: CustomerActivityListUrlFilters
): CustomerActivityListFilterOpts {
  return {
    lastLogin: {
      active: maybe(
        () =>
          [params.loginFrom, params.loginTo].some(field => field !== undefined),
        false
      ),
      value: {
        max: maybe(() => params.loginFrom, ""),
        min: maybe(() => params.loginTo, "")
      }
    },
    lastOrder: {
      active: maybe(
        () =>
          [params.lastOrderFrom, params.lastOrderTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.lastOrderFrom, ""),
        min: maybe(() => params.lastOrderTo, "")
      }
    }
  };
}

export function getFilterVariables(params: CustomerActivityListUrlFilters) {
  const newDate = new Date();
  const endDay = newDate.getDate();
  const endMonth = newDate.getMonth() + 1;
  const endYear = newDate.getFullYear();

  const startDate = moment(newDate.setMonth(newDate.getMonth() - 3)).format(
    "YYYY-MM-DD"
  );
  const endDate = moment(`${endYear}-${endMonth}-${endDay} 00:00:00`)
    .add(1, "days")
    .format("YYYY-MM-DD HH:mm:ssZZ");

  return {
    lastLogin: getGteLteVariables({
      gte: params.loginFrom
        ? moment(`${params.loginFrom} 00:00:00`).format("YYYY-MM-DD HH:mm:ssZZ")
        : !params.loginFrom && params.lastOrderFrom
        ? null
        : moment(`${startDate} 00:00:00`).format("YYYY-MM-DD HH:mm:ssZZ"),
      lte: params.loginTo
        ? moment(`${params.loginTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : !params.loginTo && params.lastOrderTo
        ? null
        : endDate
    }),
    lastOrderDate: getGteLteVariables({
      gte: params.lastOrderFrom
        ? moment(`${params.lastOrderFrom} 00:00:00`).format(
            "YYYY-MM-DD HH:mm:ssZZ"
          )
        : null,
      lte: params.lastOrderTo
        ? moment(`${params.lastOrderTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : null
    }),
    search: params.query
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<CustomerActivityFilterKeys>
): CustomerActivityListUrlFilters {
  const { name } = filter;

  switch (name) {
    case CustomerActivityFilterKeys.lastLogin:
      return getMinMaxQueryParam(
        filter,
        CustomerActivityListUrlFiltersEnum.loginFrom,
        CustomerActivityListUrlFiltersEnum.loginTo
      );
    case CustomerActivityFilterKeys.lastOrder:
      return getMinMaxQueryParam(
        filter,
        CustomerActivityListUrlFiltersEnum.lastOrderFrom,
        CustomerActivityListUrlFiltersEnum.lastOrderTo
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<CustomerActivityListUrlFilters>(
  CUSTOMER_REPORTS_FILTERS_KEY
);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  CustomerActivityUrlQueryParams,
  CustomerActivityListUrlFilters
>(CustomerActivityListUrlFiltersEnum);
